import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { ImagesContainer } from '../ImagesContainer/ImagesContainer';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import './InfoContainer.scss';

export const InfoContainer = ({ isInPromoDrawer }) => {
  const { isMsb, isBogo } = usePromoModel();

  const showFullWidth = isMsb || isInPromoDrawer;
  const promoInfoContainerClasses = classNames({
    'promo-info-container': true,
    'promo-info-container--full-width': showFullWidth,
  });

  return (
    <div className={promoInfoContainerClasses}>
      {(isBogo || isInPromoDrawer) ? <ImagesContainer /> : null}
      {isMsb ? <ProgressBar /> : null}
    </div>
  );
};

InfoContainer.displayName = 'InfoContainer';

InfoContainer.propTypes = {
  isInPromoDrawer: bool,
};

InfoContainer.defaultProps = {
  isInPromoDrawer: false,
};
